import { render, staticRenderFns } from "./NiceBanner.vue?vue&type=template&id=0477e1a2&scoped=true&"
import script from "./NiceBanner.vue?vue&type=script&lang=ts&"
export * from "./NiceBanner.vue?vue&type=script&lang=ts&"
import style0 from "./NiceBanner.vue?vue&type=style&index=0&id=0477e1a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0477e1a2",
  null
  
)

export default component.exports